import { render, staticRenderFns } from "./EditNeighbor.vue?vue&type=template&id=dc483e3e&"
import script from "./EditNeighbor.vue?vue&type=script&lang=js&"
export * from "./EditNeighbor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports